import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import Course from './../../components/Course/Course';
import { CourseContext, CommonContext } from './../../contexts/constant/ActionTypes';

const CoursePage = ({history, match}) => {
    const courseContext = useContext(CourseContext);
    const commonContext = useContext(CommonContext);
    return (
        <Course
            history={history}
            match={match}
            courseContext={courseContext}
            commonContext={commonContext}
        />  
);}

CoursePage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

CoursePage.defaultProps = {
    history: {},
    match: {}
};

export default CoursePage;



// WEBPACK FOOTER //
// ./containers/CoursePage/CoursePage.js